import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { formatDateTime } from "../utils/dateRangeUtils";

function formatPeople(people) {
  if (!people || people.length === 0) {
    return "None listed";
  }

  return people
    .map((person) => person.name || person.email)
    .filter(Boolean)
    .join(", ");
}

function getJoinUrl(assignment) {
  return assignment?.joinUrl || assignment?.onlineMeetingUrl || null;
}

export function ScheduleClassCard({ assignment }) {
  const students = assignment.students || [];
  const joinUrl = getJoinUrl(assignment);

  return (
    <Card sx={{ bgcolor: "#1A1A1A", color: "white" }}>
      <CardContent>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          gap={1}
        >
          <Box>
            <Typography variant="h6">{assignment.title || "Scheduled class"}</Typography>
            <Typography variant="body2" color="text.secondary">
              {formatDateTime(assignment.start)} - {formatDateTime(assignment.end)}
            </Typography>
          </Box>

          {assignment.online && <Chip label="Online" size="small" />}
        </Stack>

        <Divider sx={{ my: 2 }} />

        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Team:</strong> {assignment.teamName || assignment.teamId || "Not resolved"}
        </Typography>

        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Students:</strong> {formatPeople(students)}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          {students.length === 1
            ? "1 student listed"
            : `${students.length} students listed`}
        </Typography>
      </CardContent>

      <CardActions sx={{ px: 2, pb: 2, flexWrap: "wrap", gap: 1 }}>
        {joinUrl && (
          <Button
            size="small"
            variant="contained"
            href={joinUrl}
            target="_blank"
            rel="noreferrer"
            endIcon={<OpenInNewIcon />}
          >
            Join Teams meeting
          </Button>
        )}
        {assignment.webLink && (
          <Button
            size="small"
            variant="outlined"
            href={assignment.webLink}
            target="_blank"
            rel="noreferrer"
            endIcon={<OpenInNewIcon />}
          >
            Open calendar event
          </Button>
        )}
      </CardActions>
    </Card>
  );
}
